import { getElementCategory } from "../model";
// 获取节点组的位置
export const getElementsPosition = ({ elements = [], oFlowModel }) => {
    let maxLeft = Number.MIN_SAFE_INTEGER;
    let minLeft = Number.MAX_SAFE_INTEGER;
    let maxTop = Number.MIN_SAFE_INTEGER;
    let minTop = Number.MAX_SAFE_INTEGER;
    elements === null || elements === void 0 ? void 0 : elements.forEach((element) => {
        var _a, _b, _c;
        const category = getElementCategory(element);
        const ElementClass = category === 'NODE' ? (_a = oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.nodeTypeMap) === null || _a === void 0 ? void 0 : _a[element.type] : oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.groupTypeMap[element.type];
        const elementWidth = element.width ? element.width : (_b = ElementClass === null || ElementClass === void 0 ? void 0 : ElementClass.defaultConfig) === null || _b === void 0 ? void 0 : _b.width;
        const elementHeight = element.height ? element.height : (_c = ElementClass === null || ElementClass === void 0 ? void 0 : ElementClass.defaultConfig) === null || _c === void 0 ? void 0 : _c.height;
        minLeft = Math.min(minLeft, element.left);
        maxLeft = Math.max(maxLeft, element.left + elementWidth);
        minTop = Math.min(minTop, element.top);
        maxTop = Math.max(maxTop, element.top + elementHeight);
    });
    return {
        maxLeft,
        minLeft,
        minTop,
        maxTop,
    };
};
export const isInClassNames = (dom, classNames) => {
    if (dom) {
        for (let i = 0; i < classNames.length; i += 1) {
            const className = classNames[i];
            if (dom.classList.contains(className)) {
                return true;
            }
        }
        return isInClassNames(dom.parentElement, classNames);
    }
    return false;
};
//# sourceMappingURL=elemets.js.map